import { call, put } from 'redux-saga/effects'
import CollaboratorActions from 'Redux/CollaboratorRedux'
// import SelectionActions from 'Redux/SelectionRedux'
import { BuildErrorMsg } from './ApiHelpers'

export function * onCollaboratorsRequest (api, action) {
  const resp = yield call(api.getCollaborators, action.projectId)
  if (resp.ok) {
    yield put(CollaboratorActions.collaboratorsListSuccess(resp.data))
  } else {
    yield put(CollaboratorActions.collaboratorsListFailure(BuildErrorMsg(resp)))
  }
}

export function * onAddCollaboratorRequest (api, action) {
  const resp = yield call(api.createCollaborator, action.params)
  if (resp.ok) {
    yield put(CollaboratorActions.collaboratorsAddSuccess(resp.data))
    yield put(CollaboratorActions.collaboratorsListRequest(
      action.params.projectId))
  } else {
    yield put(CollaboratorActions.collaboratorsAddFailure(BuildErrorMsg(resp)))
  }
}

export function * onRemoveCollaboratorRequest (api, action) {
  const resp = yield call(
    api.deleteCollaborator, action.collaboratorId, action.projectId
  )
  if (resp.ok) {
    yield put(CollaboratorActions.collaboratorsRemoveSuccess(resp.data))
    yield put(CollaboratorActions.collaboratorsListRequest(action.projectId))
  } else {
    yield put(CollaboratorActions.collaboratorsRemoveFailure(BuildErrorMsg(resp)))
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/CollaboratorSagas.js